@import "../../common/css/variable.css";
#img-pre__wrapper {
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
}
#img-pre__wrapper .pre__item_wrapper {
    margin: 0 4px;
    width: 90px;
    height: 90px;
    border: 1px solid #cacaca;
    border-radius: 9px;
    object-fit: contain;
    cursor: pointer;
    display: flex;
    align-items: center;
}
#img-pre__wrapper .pre__item_wrapper img {
    width: 100%;
    height: auto;
    object-fit: contain;
}

.write_review_file {
    position: relative;
    background: var(--primary-color);
    display: flex;
    width: max-content;
    align-items: center;
    padding: 4px 7px;
    border-radius: 2px;
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
}
.write_review_file input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    cursor: pointer;
}
.write_review_file svg {
    vertical-align: baseline;
    height: 17px;
    width: 17px;
    fill:#ffffff;
    margin-right: 5px;
}
.areviews_file_label span {padding-left: 5px;}

.upload__error__tips {font-size: 12px; color: var(--danger-color);padding: var(--col-spacing-xs);}
